import { ReactstrapAlert } from './ReactstrapWrapper';

export const Alert = ReactstrapAlert;
export default Alert;
